var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "no-data-message", class: "no-data-message--" + _vm.align },
    [
      _c("div", { staticClass: "no-data-message__content" }, [
        _c("div", { staticClass: "no-data-message__title" }, [
          _vm._v(" " + _vm._s(_vm.noDataTitle) + " ")
        ]),
        _c("div", { staticClass: "no-data-message__description" }, [
          _vm._v(" " + _vm._s(_vm.noDataDescription) + " ")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }